import { useGetList } from 'react-admin';
import { AVATAR_TRACEABILITY_NOTES } from '@/utils/CONST';

interface Params {
    filter?: any;
    avatarId: string | undefined;
}

interface Result {
    history:
        | {
              iconId?: string;
              name: string;
              createdAt: string;
              data: {
                  auth: {
                      firstName: string;
                      lastName: string;
                      username: string;
                  };
                  customFields: {
                      coords: number[];
                      forms: any;
                      external_identification: any;
                  };
                  medias: {
                      customFields: any;
                      id: string;
                  }[];
                  signatures: any[];
              };
              customFields: any;
              forms: any;
              coords: any;
              configuration: {
                  customFields: any;
                  isForwarded: boolean;
              };
              typeNote: any;
          }[]
        | undefined;
    isLoading: boolean;
    refetch: any;
}

const useGetAvatarTraceabilityHistory = ({ avatarId }: Params): Result => {
    const { data, isLoading, refetch }: any = useGetList(
        AVATAR_TRACEABILITY_NOTES,
        {
            filter: {
                'type-item': 'traceability',
                avatarId,
            },
        },
        {
            enabled: avatarId !== undefined && avatarId !== null,
        },
    );

    return {
        history: data,
        isLoading,
        refetch,
    };
};

export default useGetAvatarTraceabilityHistory;
